import ErrorLayout from "@components/layout/ErrorLayout";

const NotFound = () => {
  return (
    <ErrorLayout
      statusCode="404"
      title="Page not found"
      description="Sorry, we couldn't find the page you're looking for."
    >
      <a
        href="/"
        className="inline-block btn-secondary text-sm rounded hover:underline hover:text-blue-500"
      >
        Go to dashboard
        <span className="inline-block ml-2" aria-hidden="true">
          &rarr;
        </span>
      </a>
    </ErrorLayout>
  );
};

export default NotFound;
